import React, { useState, useEffect } from 'react'
import {
  Card,
  Row,
  Col,
  Button,
  Form,
  Input,
  FormGroup,
  Label,
  ModalBody,
  ModalHeader,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Collapse,
  CardHeader,
  Table,
  CardBody
} from "reactstrap"
import ModalFooter from 'reactstrap/lib/ModalFooter'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import Loading from '../../../lib/loading'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import DateTime from 'react-datetime'
import useForm from 'lib/useForm'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {homepage} from '../../../../package.json';
import Switch from 'react-switch';

const formSwal = withReactContent(Swal)

const FormConvenio = ({ fechaModal, convenio_id, convenio, conv_cnpj, tab}) => {

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm({'fechamento':'', 'vencimento':'', 'convenio_id':convenio_id})
  const [loading, setLoading]               = useState(false)
  const [activeTab, setActiveTab]           = useState(tab)
  const [fechamentos, setFechamentos]       = useState([])
  const [fechamentoConv, setFechamentoConv] = useState('')
  const [detalhes, setDetalhes]             = useState([])
  const [validacao, setValidacao]           = useState('')
  const [row_detalhes, setRow_detalhes]     = useState([])
  const [stateSwitch, setStateSwitch]       = useState(false);


  const collapsesToggle = (id) => {
    setDetalhes((prevState) =>
      prevState.map((item) =>
        item.cliente_id === id ? { ...item, isOpen: !item.isOpen } : item
      )
    );
  };

  const toggleSelecionado = (ficharioId, clienteId) => {
    setDetalhes((prevState) =>
      prevState.map((item) =>
        item.cliente_id === clienteId
          ? {
              ...item,
              itens: item.itens.map((produto) =>
                produto.fichario_id === ficharioId
                  ? { ...produto, selecionado: !produto.selecionado }
                  : produto
              ),
            }
          : item
      )
    );
  };

  const toggleSelecionadoParcelamento = (crediarioId, clienteId) => {
    setDetalhes((prevState) =>
      prevState.map((item) =>
        item.cliente_id === clienteId
          ? {
              ...item,
              parcelamento: item.parcelamento.map((parcela) =>
                parcela.crediario_id === crediarioId
                  ? { ...parcela, selecionado: !parcela.selecionado }
                  : parcela
              ),
            }
          : item
      )
    );
  };

  const selecionaAll = (value) =>{
    let lista = detalhes

    lista.map((clientes) => {
      clientes.itens.map((produtos) =>{
        produtos.selecionado = value
      })
    })

    lista.map((clientes) => {
      clientes.parcelamento.map((parcela) =>{
        parcela.selecionado = value
      })
    })

    setDetalhes(lista)
    setStateSwitch(!stateSwitch)
  }

  const excluirSelecionados = () =>{
    // remove os ficharios não selecionados
    const lista = detalhes.map((item) => {
      const updatedItens = item.itens.filter((it) => it.selecionado);
      return { ...item, itens: updatedItens };
    });

    //remove parcelamento não selecionados
    const lista2 = lista.map((cliente) => {
      const updatedParcelamento = cliente.parcelamento.filter((it) => it.selecionado);
      return { ...cliente, parcelamento: updatedParcelamento };
    });

    formSwal.queue([{
      title:                'Deseja excluir o(s) item(ns) selecionado(s) do fechamento do convênio?',
      confirmButtonText:    'Excluir',
      showCancelButton:     true,
      // html:                 '<p> Foram selecionados '+(fichario.length + parcelamento.length)+' item(ns) do fechamento</p>',
      showLoaderOnConfirm:  true,
      cancelButtonColor:    '#d33',
      preConfirm: () => {
        formSwal.fire('Excluindo o(s) item(ns)!', 'Isso pode levar alguns minutos.', '')

        const url = rotas.fechaConvenio+'/removerItens.php'
        try{
          const retorno = rest.post(url, {fechamento: row_detalhes, selecionados: lista2})
          retorno.then(ret => {
            console.log(ret)
            if (ret.success && ret.success == 'S') {
              lista_detalhe(ret.fechamento_conv_id, [])
              lista_fechamento()
              row_detalhes.valor_fechamento = ret.valor_fechamento
              formSwal.fire('Fechamento foi Atualizado!', 'Itens selecionados excluidos do Fechamento de convênio', 'success')
              setStateSwitch(false)
            }else{
              formSwal.fire('Erro na exclusão dos itens!', ret.msg, 'error')
            }
          })
          return (true)
        }catch(err){
          formSwal.fire('Erro!',err,'error')
          console.log(err)
        }
      }
    }])
  }

  const recalculaConvenio = () => {
    const url = rotas.fechaConvenio+'/recalculaConvenio.php'
    try {
      const retorno = rest.post(url, {fechamento: row_detalhes})
      retorno.then(ret => {
        if (ret.success && ret.success == 'S') {
          setRow_detalhes({...row_detalhes, valor_fechamento: parseFloat(ret.valor_fechamento).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})})
          lista_fechamento()
          formSwal.fire('Valor Recalculado!', 'Valor do fechamento atualizado com sucesso.', 'success')
        } else {
          formSwal.fire('Erro ao recalcular!', ret.msg, 'error')
        }
      })
    } catch(err) {
      formSwal.fire('Erro!', err, 'error')
      console.log(err)
    }
  }

  const colunasFechamento = [
    {
      dataField: 'fechamento_conv_id',
      text: 'Cód',
      align: 'center',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'data_fechamento',
      text: 'Fechamento',
      align: 'center',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'vencimento',
      text: 'Vencimento',
      align: 'center',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'valor_fechamento',
      text: 'Valor',
      align: 'center',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'data_pagamento',
      text: 'Pagamento',
      align: 'center',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'pdf',
      text: 'PDF',
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: '60px', textAlign: 'center' };
      },
      formatter: (cellContent, row) => {
        return (
          <>
          <Button
            id="btnPdf"
            className="btn-icon"
            title="Fechamento Detalhado"
            color="info"
            size="md"
            type="button"
            onClick={() => gerarPDF(row)}
          >
            <i className="fas fa-file-pdf-o" />
          </Button>
          <Button
            id="btnPdfTot"
            className="btn-icon"
            title="Fechamento Totalizado"
            color="warning"
            size="md"
            type="button"
            onClick={() => gerarPDFTotalizado(row)}
          >
            <i className="fas fa-file-pdf-o" />
          </Button>
          
          {typeof row.data_pagamento == 'string' ?
            <>
              <Button
                id="btnRecibo"
                className="btn-icon"
                title="Recibo Pagamento"
                color="success"
                size="md"
                type="button"
                onClick={() => gerarPDFRecibo(row)}
              >
                <i className="fas fa-book" />
              </Button>
              <Button
                id="btnRecibo"
                className="btn-icon"
                title="Exportação TXT"
                color="muted"
                size="md"
                type="button"
                onClick={() => gerarImportacao(row)}
              >
                <i className="fas fa-file-code-o" />
              </Button>
            </>
          : '' }
          </>
        )
      }
    }
  ]

  const gerarPDF = (row) => {
    
    let urlFechamento = homepage + '/webgestor/api/convenios/fechamento/pdf';
    let url = rotas.fechaConvenio+'pdf/index.php'

    try{
      let rede      = sessionStorage.getItem('rede'),
          usuario   = sessionStorage.getItem('usuario')
      
      const retorno = rest.post(url, {'fechamento_conv_id':row.fechamento_conv_id, 'convenio_id':row.convenio_id, 'rede':rede, 'usuario':usuario})
      retorno.then(ret => {
        console.log(ret)
        if (ret.success == 'S') {

          const pdfWindow = window.open();

          pdfWindow.location.href = urlFechamento + ret.path; 
        }else{
          formSwal.fire('Erro na geração do PDF!', ret.msg, 'error')
        }
      })
      return (true)
    }catch(err){
      formSwal.fire('Erro!',err,'error')
      console.log(err)
    }
  }

  const gerarPDFTotalizado = (row) => {
    let urlFechamento = homepage + '/webgestor/api/convenios/fechamento/pdf';
    let url = rotas.fechaConvenio+'pdf/totalizado.php'

    try{
      let rede      = sessionStorage.getItem('rede'),
          usuario   = sessionStorage.getItem('usuario')
      
      const retorno = rest.post(url, {'fechamento_conv_id':row.fechamento_conv_id, 'convenio_id':row.convenio_id, 'rede':rede, 'usuario':usuario})
      retorno.then(ret => {
        console.log(ret)
        if (ret.success == 'S') {

          const pdfWindow = window.open();

          pdfWindow.location.href = urlFechamento + ret.path; 
        }else{
          formSwal.fire('Erro na geração do PDF!', ret.msg, 'error')
        }
      })
      return (true)
    }catch(err){
      formSwal.fire('Erro!',err,'error')
      console.log(err)
    }
  }

  const gerarPDFRecibo = (row) => {
    let urlFechamento = homepage + '/webgestor/api/convenios/fechamento/recibo';
    let url = rotas.fechaConvenio+'recibo/'

    try{
      let rede      = sessionStorage.getItem('rede'),
          usuario   = sessionStorage.getItem('usuario')
      
      const retorno = rest.post(url, {'fechamento_conv_id':row.fechamento_conv_id, 'convenio_id':row.convenio_id, 'rede':rede, 'usuario':usuario})
      retorno.then(ret => {
        console.log(ret)
        if (ret.success == 'S') {

          const pdfWindow = window.open();

          pdfWindow.location.href = urlFechamento + ret.path; 
        }else{
          formSwal.fire('Erro na geração do PDF!', ret.msg, 'error')
        }
      })
      return (true)
    }catch(err){
      formSwal.fire('Erro!',err,'error')
      console.log(err)
    }
  }

  const gerarImportacao = (row) => {
    let urlFechamento = homepage + '/webgestor/api/convenios/fechamento/importacao';
    let url = rotas.fechaConvenio+'importacao/'

    try{
      let rede      = sessionStorage.getItem('rede'),
          usuario   = sessionStorage.getItem('usuario')
      
      const retorno = rest.post(url, {'fechamento_conv_id':row.fechamento_conv_id, 'convenio_id':row.convenio_id, 'rede':rede, 'usuario':usuario})
      retorno.then(ret => {
        console.log(ret)
        if (ret.success == 'S') {

          // const pdfWindow = window.open();
          // pdfWindow.location.href = urlFechamento + ret.path;

            const element = document.createElement("a");
            const file = new Blob([ret.texto], {type: 'text/plain'});
            element.href = URL.createObjectURL(file);
            element.download = "importacao.txt";
            document.body.appendChild(element); // Required for this to work in FireFox
            element.click();

        }else{
          formSwal.fire('Erro na geração da importação TXT!', ret.msg, 'error')
        }
      })
      return (true)
    }catch(err){
      formSwal.fire('Erro!',err,'error')
      console.log(err)
    }
  }

  const lista_fechamento = () => {
    let lista = []
    const url = rotas.fechaConvenio+'/'+convenio_id
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success=='S' && ret.lista && ret.lista != ''){
          lista = ret.lista

          for (let i = 0; i < lista.length; i++) {
            
            lista[i].valor_fechamento = parseFloat(lista[i].valor_fechamento).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
            if (lista[i].data_pagamento === '') {
              lista[i].data_pagamento   = <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Aberto</span></div>
            }
          }

          setFechamentos(lista)
        }
        setLoading(false)
      })
      return (true)
    }catch(err){
      console.log(err)
    }
  }

  const lista_detalhe = (fechamentoId, pagamento) => {
    setDetalhes([])
    setStateSwitch(false)

    let lista         = []

    if (typeof pagamento != 'string') {

      const url = rotas.fechaConvenio+'/detalhes.php'
      try{
        const retorno = rest.post(url, {'fechamento':fechamentoId})
        retorno.then(ret => {
          if (ret.success=='S' && ret.lista != ''){
            lista = ret.lista
            for (let i = 0; i < lista.length; i++) {
              // console.log(lista[i])
              // lista[i].fichario_valor = parseFloat(lista[i].fichario_valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
              // lista[i].fichario_valor = parseFloat(lista[i].fichario_valor)
              // lista[i].fichario_quantidade = parseFloat(lista[i].fichario_quantidade)
              lista[i].total = parseFloat(lista[i].total).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
            }
            setDetalhes(lista)
          }
          setLoading(false)
        })
        return (true)
      }catch(err){
        console.log(err)
      }
    } else {
      console.log('Convênio ja pago')
    }
  }

  useEffect(() => {
    lista_fechamento()
  },[])

  const recebimentoConv = () => {

    formSwal.queue([{
      title:                'Deseja Fazer o recebimento do convênio?',
      confirmButtonText:    'Receber',
      showCancelButton:     true,
      html:                 '<p>Convênio '+convenio+'</p> <p> Fechamento de código '+fechamentoConv,
      showLoaderOnConfirm:  true,
      cancelButtonColor:    '#d33',
      preConfirm: () => {
        formSwal.fire('Efetuando o recebimento do convênio!', 'Isso pode levar alguns minutos.', '')

        const url = rotas.fechaConvenio+'/recebeConv.php'
        try{
          const retorno = rest.post(url, {'convenio_id':convenio_id, 'fechamento':fechamentoConv})
          retorno.then(ret => {
            // console.log(ret)
            if (ret.success == 'S') {
              lista_fechamento()
              formSwal.fire('Convênio Recebido!', 'Recebimento efetuado com sucesso.', 'success')
              setActiveTab('2')
            }else{
              formSwal.fire('Erro no Recebido!', ret.msg, 'error')
            }
          })
          return (true)
        }catch(err){
          formSwal.fire('Erro!',err,'error')
          console.log(err)
        }
      }
    }])
  }

  const cancelaFechamento = () => {
    formSwal.queue([{
      title:                'Deseja Cancelar o Fechamento ?',
      confirmButtonText:    'Efetuar Cancelamento',
      showCancelButton:     true,
      html:                 '<p>Convênio '+convenio+'</p> <p> Fechamento de código '+fechamentoConv,
      showLoaderOnConfirm:  true,
      cancelButtonColor:    '#d33',
      preConfirm: () => {
        formSwal.fire('Efetuando o cancelamento do fechamento!', 'Isso pode levar alguns minutos.', '')

        const url = rotas.fechaConvenio+'/excluirFechamento.php'
        try{
          const retorno = rest.post(url, {'fechamento':fechamentoConv})
          retorno.then(ret => {
            // console.log(ret)
            if (ret.success == 'S') {
              lista_fechamento()
              setActiveTab('2')
              formSwal.fire('Fechamento Cancelado!', 'Cancelamento efetuado com sucesso.', 'success')
            }else{
              formSwal.fire('Erro no Cancelamento!', ret.msg, 'error')
            }
          })
          return (true)
        }catch(err){
          formSwal.fire('Erro!',err,'error')
          console.log(err)
        }
      }
    }])

  }

  const fechamentoSubmit = (evt) => {
    evt.preventDefault()
    // setLoading(true)

    if (form.fechamento == '' && form.vencimento == '') {
      // console.log('valores em branco')
      setValidacao('has-danger')
      return false
    }

    setValidacao('has-success')

    formSwal.queue([{
      title:                'Gerar Fechamendo do Convênio?',
      confirmButtonText:    'Gerar',
      showCancelButton:     true,
      html:                 '<p>Convênio '+convenio+'</p> <p>Período até a data '+form.fechamento+'</p> <p>Vencimento </p>'+form.vencimento,
      showLoaderOnConfirm:  true,
      cancelButtonColor:    '#d33',
      preConfirm: () => {
        const url = rotas.fechaConvenio+'/fechaConv.php'
        return rest.post(url, form)
          .then(ret => {
            // console.log(ret)
            if (ret.success == 'S') {
              if (ret.valor_fechamento > 0) {
                formSwal.fire('Fechamento Gerado!', '<p>Valor do fechamento: '+parseFloat(ret.valor_fechamento).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})+'</p> <p> Vencimento para o dia  '+form.vencimento+'</p>', 'success')
                lista_fechamento()
              }else{
                formSwal.fire('Não existe fechamento para esse Convênio!', 'Não existe valores para se fechar', '')
              }
              // lista_detalhe(ret.fechamento)
              // setActiveTab('3')
            }else{
              formSwal.fire('Erro!',ret.msg,'error')
            }
          })
      }
    }])
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  } else {
    return (
      <>
      {/* MODAL DE CADASTRO E EDIÇÃO */}
      <Card>
        <ModalHeader>
          <Row>
            <Col>
              <CardTitle>{convenio} - {conv_cnpj}</CardTitle>
            </Col>
          </Row>
        </ModalHeader>

        <ModalBody>
          <Nav pills className="nav-pills-default justify-content-center mb-4">
            <NavItem>
              <NavLink
                className={activeTab == '1' ? 'active' : ''}
                onClick={() => setActiveTab('1')}
              >
                Fazer fechamento
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={activeTab == '2' ? 'active' : ''}
                onClick={() => setActiveTab('2')}
              >
                Fechamentos realizados
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={activeTab == '3' ? 'active' : ''}
                // onClick={() => setActiveTab('3')}
              >
                Detalhe/Cliente
              </NavLink>
            </NavItem>
          </Nav>

          {/* FAZER FECHAMENTO */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Form onSubmit={fechamentoSubmit} >
                <Col md={{size: 4, offset: 4}}>
                  <FormGroup className={validacao}>
                    <Label for="emissao">Data Fechamento</Label>
                    <DateTime
                      id            = "dataFechamento"
                      name          = "dataFechamento"
                      // inputProps    = {{ placeholder: "__/__/____", className: "form-control" }}
                      closeOnSelect = {true}
                      dateFormat    = "DD/MM/YYYY"
                      timeFormat    = {false}
                      value         = {form.fechamento}
                      onChange      = {onChangeDate('fechamento')}
                      inputProps  = {{
                        // disabled:true,
                        // readOnly: true,
                        className: "form-control",
                        placeholder: "__/__/____",
                        onKeyDown: (e) => { e.preventDefault() }
                      }}
                    >
                    </DateTime>
                  </FormGroup>

                  <FormGroup className={validacao}>
                    <Label for="emissao">Data Vencimento</Label>
                    <DateTime
                      id            = "dataVencimento"
                      name          = "dataVencimento"
                      // inputProps    = {{ placeholder: "__/__/____", className: "form-control" }}
                      closeOnSelect = {true}
                      dateFormat    = "DD/MM/YYYY"
                      timeFormat    = {false}
                      value         = {form.vencimento}
                      onChange      = {onChangeDate('vencimento')}
                      inputProps  = {{
                        // disabled:true,
                        // readOnly: true,
                        className: "form-control",
                        placeholder: "__/__/____",
                        onKeyDown: (e) => { e.preventDefault() }
                      }}
                    >
                    </DateTime>
                  </FormGroup>

                  <Col className="text-center p-3">
                    <Button type="submit" className="mb-0 mt-0" color="info" size="md">
                      Fazer fechamento
                    </Button>
                  </Col>
                </Col>
              </Form>
            </TabPane>
          </TabContent>

          {/* FECHAMENTOS REALIZADOS */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="2">

              <Col>
                <ToolkitProvider
                  keyField  = "id"
                  data      = {fechamentos}
                  columns   = {colunasFechamento}
                >
                  {
                    props => (
                      <div>
                        <BootstrapTable
                          striped
                          hover
                          //remote
                          keyField          ='id'
                          noDataIndication  = "Nenhum registro encontrado"
                          rowStyle          = {{ cursor: "pointer" }}
                          data              = {fechamentos}
                          columns           = {colunasFechamento}
                          rowEvents         = {{
                            onDoubleClick: (e, row, rowIndex) => {
                              // console.log(row)
                              if (typeof row.data_pagamento != 'string') {
                                setRow_detalhes(row)
                                setFechamentoConv(row.fechamento_conv_id)
                                lista_detalhe(row.fechamento_conv_id, row.data_pagamento)
                                setActiveTab('3')
                              } else {
                                console.log('fechamento ja pago')
                              }
                            }
                          }}
                          pagination        = {paginationFactory({
                            sizePerPage: 10,
                            hideSizePerPage: true,
                            hidePageListOnlyOnePage: true,
                            showTotal: false,
                          })}
                          {...props.baseProps}
                        />
                      </div>
                    )
                  }
                </ToolkitProvider>
              </Col>

            </TabPane>
          </TabContent>

          {/* DETALHE/CLIENTE */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="3">
              <Row className="mb-2">
                <Col md="3">
                  <Label>Código Fechamento</Label>
                  <Input
                    type="text"
                    name="fornecedor"
                    disabled
                    defaultValue={row_detalhes.fechamento_conv_id ? row_detalhes.fechamento_conv_id : ''}
                  />
                </Col>
                <Col>
                  <Label>Data Fechamento</Label>
                  <Input
                    type="text"
                    name="emissao"
                    disabled
                    defaultValue={row_detalhes.data_fechamento ? row_detalhes.data_fechamento : ''}
                  />
                </Col>
                <Col>
                  <Label>Data Vencimento</Label>
                  <Input
                    type="text"
                    name="entrada"
                    disabled
                    defaultValue={row_detalhes.vencimento ? row_detalhes.vencimento : ''}
                  />
                </Col>
                <Col>
                  <Label>Valor</Label>
                  <Input
                    type="text"
                    name="serie"
                    disabled
                    value={row_detalhes.valor_fechamento ? row_detalhes.valor_fechamento : ''}
                  />
                </Col>
              </Row>

              <Col className="text-right p-3">
                <Button type="button" className="mb-0 mt-0" color="success" size="sm" onClick={ () => recebimentoConv()}>
                  Efetuar Recebimento
                </Button>
                <Button type="button" className="mb-0 mt-0" color="primary" size="sm" onClick={ () => cancelaFechamento()}>
                  Cancelar Fechamento
                </Button>
                <Button type="button" className="mb-0 mt-0" color="info" size="sm" onClick={ () => excluirSelecionados()}>
                  Excluir Selecionados
                </Button>
                <Button type="button" className="btn-icon mb-0 mt-0" color="warning" size="sm" title="Recalcular valor do convênio" onClick={ () => recalculaConvenio()}>
                  <i className="fas fa-sync-alt" />
                </Button>
              </Col>

{/* inicio colapse */}
              <Col>
              <div
                aria-multiselectable={true}
                className="card-collapse"
                id="accordion"
                role="tablist"
              >
                <Col className="text-right p-0" >
                  <span className="mb-0 m-2" >Selecionar todos </span>
                  <Switch
                    id        = 'btn-selecionaAll'
                    height    = {15}
                    width     = {35}
                    checked   = {stateSwitch}
                    onChange  = {(e)=>{selecionaAll(e)}}
                    // onColor='#080'
                  />
                </Col>
                {detalhes.map((item, index) => (
                  <Card className="card-plain" key={item.cliente_id}>
                    <CardHeader role="tab" className="title">
                      <a
                        aria-expanded={item.isOpen}
                        href="#pablo"
                        data-parent="#accordion"
                        data-toggle="collapse"
                        onClick={(e) => {
                          e.preventDefault();
                          collapsesToggle(item.cliente_id);
                        }}
                      >
                        {'Cliente ID: '+item.cliente_id +' - Nome: '+ item.cliente +' - Valor total: '+item.total} <i className="nc-icon nc-minimal-down" />
                      </a>
                    </CardHeader>
                    <Collapse role="tabpanel" isOpen={item.isOpen}>
                      <CardBody>
                        { item.itens && item.itens.length !== 0 ? 
                          <>
                            <CardTitle><h6 >Fichário</h6></CardTitle> 
                            <Table>
                              <thead>
                                <tr>
                                  <th>VENDA</th>
                                  <th>ITEM</th>
                                  <th>PRODUTO</th>
                                  <th>COMPRA</th>
                                  <th>VENCIMENTO</th>
                                  <th>QTD</th>
                                  <th>VALOR</th>
                                  <th>FRETE</th>
                                  <th>TOTAL</th>
                                  <th>Excluir</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.itens.map((produto, index) => (
                                  <tr key={produto.fichario_id}>
                                    <td>{produto.venda_nota_id}</td>
                                    <td>{produto.item_venda_id}</td>
                                    <td>{produto.produto_id}</td>
                                    <td>{produto.fichario_datacompra}</td>
                                    <td>{produto.fichario_vencimento}</td>
                                    <td>{produto.fichario_quantidade}</td>
                                    <td>{parseFloat(produto.fichario_valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                                    <td>{parseFloat(produto.fichario_frete).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                                    <td>{parseFloat((parseFloat(produto.fichario_quantidade) * parseFloat(produto.fichario_valor)) + parseFloat(produto.fichario_frete)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                                    <td>
                                      <Switch
                                        className="react-switch"
                                        height={15}
                                        width={35}
                                        checked={produto.selecionado}
                                        onChange={() =>
                                          toggleSelecionado(produto.fichario_id, item.cliente_id)
                                        }
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </>
                          : '' }

                        { item.parcelamento && item.parcelamento.length !== 0 ? 
                          <>
                            <CardTitle><h6 className="title">Parcelamento</h6></CardTitle> 
                            <Table>
                              <thead>
                                <tr>
                                  <th>VENDA</th>
                                  <th>CREDIARIO</th>
                                  <th>PARCELA</th>
                                  <th>VALOR</th>
                                  <th>VENCIMENTO</th>
                                  <th>Excluir</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.parcelamento.map((parcelamento, index) => (
                                  <tr key={parcelamento.fichario_id}>
                                    <td>{parcelamento.venda_nota_id}</td>
                                    <td>{parcelamento.crediario_id}</td>
                                    <td>{parcelamento.crediario_parcela}</td>
                                    <td>{parseFloat(parcelamento.crediario_valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                                    <td>{parcelamento.crediario_vencimento}</td><td>
                                      <Switch
                                        className="react-switch"
                                        height={15}
                                        width={35}
                                        checked={parcelamento.selecionado}
                                        onChange={() =>
                                          toggleSelecionadoParcelamento(parcelamento.crediario_id, item.cliente_id)
                                        }
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </>
                          : '' }

                      </CardBody>
                    </Collapse>
                  </Card>
                ))}
              </div>

              </Col>
            </TabPane>
          </TabContent>

        </ModalBody>

        <ModalFooter>
          <Col className="text-center p-3">
            <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
              Fechar
            </Button>
          </Col>
        </ModalFooter>
      </Card>
      {/* MODAL DE CADASTRO E EDIÇÃO end */}
      </>
    );
  }
}

export default FormConvenio;
